export const FETCH_CUSTOMER_REQUEST = 'CUSTOMER.FETCH_CUSTOMER_REQUEST';
export const FETCH_CUSTOMER_SUCCESS = 'CUSTOMER.FETCH_CUSTOMER_SUCCESS';
export const FETCH_CUSTOMER_FAILURE = 'CUSTOMER.FETCH_CUSTOMER_FAILURE';

export const FETCH_CUSTOMERS_REQUEST = 'CUSTOMER.FETCH_CUSTOMERS_REQUEST';
export const FETCH_CUSTOMERS_SUCCESS = 'CUSTOMER.FETCH_CUSTOMERS_SUCCESS';
export const FETCH_CUSTOMERS_FAILURE = 'CUSTOMER.FETCH_CUSTOMERS_FAILURE';


// WEBPACK FOOTER //
// ./src/constants/Customer.ts